import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';

export enum InputSource {
	TOOLBAR = INPUT_METHOD.TOOLBAR,
	KEYBOARD = INPUT_METHOD.KEYBOARD,
	EXTERNAL = INPUT_METHOD.EXTERNAL,
}
